import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_URL } from '../../../config';

function ModalAdmin({ selectedRow }) {
  const [loading, setLoading] = useState(false);
  const [, setError] = useState(null);
  const navigate = useNavigate();

  const handleToggleLock = async (userId) => {

    if (!userId) {
      setError("ID de l'annonce non valide.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token introuvable. Veuillez vous reconnecter.");
      }
      const response = await fetch(`${API_URL}/api/user/togglelockstatus`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id: userId }),
      });

      if (!response.ok) {
        // Si le serveur retourne une erreur (comme 404 ou 500)
        const errorData = await response.json();
        throw new Error(errorData.message || "Erreur lors de la mise à jour.");
      }

      await response.json();
      alert(`Statut a été mis jour avec succès!`);
      navigate(0); // Cela recharge la page actuelle
    } catch (error) {
      setError(error.message);
      console.error("Erreur :", error.message);
      alert(`Une erreur s'est produite : ${error.message}`);
    } finally {
      setLoading(false);
    }
  };  

  return (
    <div className="modal fade" role="dialog" tabIndex="-1" id="confirmModal">
      <div className="modal-dialog modal-dialog-scrollable" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title text-primary" id="detailModalLabel">
             Confirmation requise
            </h4>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Fermer"
            ></button>
          </div>
          <div className="modal-body">
            {selectedRow && (
                <p>               
                    <span>Voulez-vous {selectedRow[5]==='Bloqué'?'débloquer':'bloquer'} l'administrateur {selectedRow[0]} ?</span>
                </p>
            )}
          </div>
          <div className="modal-footer">
            <button
              className="btn btn-success"
              type="button"
              disabled={loading}
              onClick={() => handleToggleLock(selectedRow?.[7])}
            >
              {loading ? "Chargement..." : 'Oui'}
            </button>
            <button
              className="btn btn-danger"
              type="button"
              data-bs-dismiss="modal"
              disabled={loading}
            >
              Non
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalAdmin;